import { useCallback, useEffect } from 'react';

export const useCtrlKey = ({ callback }: { callback: (pressed: boolean) => void }) => {
  const onKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Control') {
        callback(false);
      }
    },
    [callback]
  );

  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Control') {
        callback(true);
      }
    },
    [callback]
  );

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyDown, onKeyUp]);
};
